import { INickNameRet, IUser } from '@/entity/service.interface'
import { localUserKey, sessionToken } from '@/entity/system.interface'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { message } from 'antd'
// import { message } from 'antd'
import { changeError } from './page'

import { getUsers, nftLogin, upsertAccount } from '@/api'

interface IWalletState {
  loading: boolean // 钱包loading
  user?: IUser
  iserror?: boolean
  changedAddress?: string
  addLoading: boolean
}
const initialState: IWalletState = {
  loading: false,
  user: undefined,
  addLoading: false,
  changedAddress: '',
}
const loginThunk = createAsyncThunk<IUser>('wallet_login', async (_, { dispatch }): Promise<IUser> => {
  dispatch(changeLoading(true))
  try {
    let saveUser: IUser | undefined = undefined
    const address = window.web3Modal.getAddress() //state.wallet.user?.currentAddress
    const text = 'SpaceN Authoriation'
    const signature = await window.web3.eth.personal.sign(text, address)
    const users = await getUsers({
      authData: {
        moralisEth: {
          data: text,
          id: address,
          signature,
        },
      },
    })
    // createAt objectId sessionToken updateAt

    saveUser = {
      objectId: users.objectId,
      currentAddress: address,
      wallets: [{ walletname: 'wallet01', address: address }],
      token: users.sessionToken,
    }
    sessionStorage.setItem(sessionToken, users.sessionToken)

    const nft = await nftLogin({
      addr: address,
    })
    if (nft.success) {
      const data = nft.data
      if (data) {
        // 登录成功
        Object.assign(saveUser, {
          objectId: data.objectId,
          wallets: data.addrs,
          nickname: data.nickName,
        })
      }
    } else if (nft.code === 209) {
      dispatch(reloginThunk())
    } else {
      // 登录失败, 重置user
      Object.assign(saveUser, { objectId: undefined })
    }
    return saveUser
  } catch (e: any) {
    dispatch(changeError(e.message))
    message.error(e.message)
    window.web3Modal.disconnect()
    throw e
  } finally {
    dispatch(changeLoading(false))
    dispatch(setChangedAccount(''))
  }
})

const reloginThunk = createAsyncThunk('wallet_relogin', async (_, { dispatch }): Promise<any> => {
  try {
    // sessiontoken失效
    dispatch(setUserInfoByLocal(undefined))
    sessionStorage.removeItem(localUserKey)
    sessionStorage.removeItem(sessionToken)
    const res = await dispatch(loginThunk()).unwrap()
    return res
  } catch (e: any) {
    dispatch(changeError(e.message))
    message.error(e.message)
    throw e
  }
})

export interface IUpdateAccountOpt {
  objectId?: string
  nickName: string
  avator?: string
  addrs: { walletname?: string; address: string; main?: boolean }[]
}

// 修改昵称
const regNickNameThunk = createAsyncThunk<INickNameRet, IUpdateAccountOpt>(
  'wallet_reg_nickname',
  async (opt: IUpdateAccountOpt, { dispatch }): Promise<INickNameRet> => {
    dispatch(changeLoading(true))
    try {
      console.log('upsertAccount opt:', opt)
      const res = await upsertAccount(opt)
      console.log('upsertAccount::', res)
      if (res.success && res.data) {
        const addressList = res.data.get ? res.data.get('addrs') : res.data.addrs
        const nickName = res.data.get ? res.data.get('nickName') : res.data.nickName
        console.log('nick::', nickName, addressList, res.data.id || res.data.objectId, res.data)
        return { objectId: res.data.id || res.data.objectId, nickname: nickName, wallets: addressList }
      } else {
        throw new Error(res.data)
      }
    } catch (e: any) {
      dispatch(changeError(e.message))
      throw e
    } finally {
      dispatch(changeLoading(false))
    }
  },
)
// 添加钱包
const addAddressToWebThunk = createAsyncThunk(
  'wallet_address_is_right',
  async (address: string | undefined, { dispatch, getState }) => {
    dispatch(changeLoading({ key: 'addwallet', value: true }))
    try {
      if (address) {
        console.log('changeAccount:', address)
        const state: any = getState()
        const user: IUser = state && state.wallet && state.wallet.user
        // 查询此地址在钱包列表没
        if (user && user.wallets && user.wallets.findIndex((r) => r.address === address) >= 0) {
          return window.message.warning('Address already registered')
        }
        try {
          await window.Moralis.link(address)
        } catch (e: any) {
          if (e.code === 208) {
            // 此账户已经使用过
            window.message.warning('Address already registered')
            return
          }
        }
        // 使用此地址，调用upsertAccount，来更新钱包
        const len = user.wallets.length > 9 ? user.wallets.length + 1 : `0${user.wallets.length + 1}`
        const opt: IUpdateAccountOpt = {
          objectId: user.objectId,
          nickName: user.nickname ?? '',
          addrs: user.wallets.concat({ walletname: `wallet${len}`, address: address }),
        }
        await dispatch(regNickNameThunk(opt)).unwrap()
        window.message.success('Registration successful')
      }
    } catch (e: any) {
      console.log('e--', e)
      window.message.warning('Registration failed')
    } finally {
      dispatch(changeLoading({ key: 'addwallet', value: false }))
    }
  },
)
const SaveUserToLocal = (saved: any) => {
  const info = sessionStorage.getItem(localUserKey)
  const pInfo = info && JSON.parse(info)
  if (pInfo && saved) {
    console.log('pinfo, saved::', pInfo, saved)
    sessionStorage.setItem(localUserKey, JSON.stringify(Object.assign({}, pInfo, saved)))
  } else {
    sessionStorage.setItem(localUserKey, JSON.stringify(saved))
  }
}
// 退出登录
const layoutThunk = createAsyncThunk('wallet_layout', async (_, { dispatch }) => {
  dispatch(changeLoading(true))
  try {
    dispatch(setUserInfoByLocal(undefined))
    sessionStorage.removeItem(localUserKey)
    sessionStorage.removeItem(sessionToken)
    await window.web3Modal.disconnect()
    window.message.info('You logged out successfully!')
  } catch (e) {
  } finally {
    dispatch(changeLoading(false))
  }
})
const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    changeLoading: (state, actions) => {
      if (typeof actions.payload === 'boolean') {
        state.loading = actions.payload
      } else {
        switch (actions.payload.key) {
          case 'addwallet':
            state.addLoading = actions.payload.value
            break
        }
      }
    },
    changeAddressLink: (state, actions) => {
      state.user = Object.assign({}, state.user, { currentAddress: actions.payload })
    },
    setUserInfoByLocal: (state, actions) => {
      console.log('actions----', actions.payload)
      if (actions.payload) {
        state.user = Object.assign({}, state.user, actions.payload)
      } else {
        state.user = undefined
      }
    },
    setChangedAccount: (state, actions) => {
      console.log('change account---', actions.payload)
      state.changedAddress = actions.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginThunk.fulfilled, (state, actions) => {
        state.user = actions.payload
        SaveUserToLocal(actions.payload)
      })
      .addCase(regNickNameThunk.fulfilled, (state, actions) => {
        state.user = Object.assign({}, state.user, actions.payload)
        SaveUserToLocal(actions.payload)
      })
  },
})
export const reducer = walletSlice.reducer
export const { changeLoading, setUserInfoByLocal, setChangedAccount, changeAddressLink } = walletSlice.actions
export { loginThunk, regNickNameThunk, addAddressToWebThunk, layoutThunk, reloginThunk }
